
export function logToBackend(message: string, data?: any) {
  fetch(`${process.env.REACT_APP_SERVER_API_URL}/patient/moneris-logs`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ message, meta: data }),
  }).catch((err) => {
    console.error("Failed to send log to backend", err);
  });
}
